/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { KeyValuePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { CheckboxEditorComponent } from '@odc/component';
import { uniqueId } from 'lodash-es';
import { UserFormService } from '../user.formservice';

@Component({
  selector: 'administration-user-form-organisations-einheit-list',
  imports: [ReactiveFormsModule, KeyValuePipe, CheckboxEditorComponent, KeyValuePipe],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './user-form-organisations-einheit-list.component.html',
})
export class UserFormOrganisationsEinheitListComponent implements OnInit {
  private readonly formService = inject(UserFormService);

  public organisationsEinheitenGroup: UntypedFormGroup;
  public readonly headingId: string = uniqueId('organisationseinheiten-heading-');
  public readonly descriptionId: string = uniqueId('organisationseinheiten-desc-');

  ngOnInit(): void {
    this.organisationsEinheitenGroup = this.formService.getOrganisationsEinheitenGroup();
  }

  public readonly UserFormService = UserFormService;
}
